import NextLink from 'next/link';

import { useUiState } from 'hooks/useUiState';

export type LinkProps = {
  children: React.ReactNode;
  to: string;
  transition?: boolean;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const Link = ({
  children,
  to,
  transition = true,
  ...props
}: LinkProps) => {
  // prop: transiton = opt in or out of a page transition
  // (i.e tabs might not require a transition)
  // defaults to active page transitions
  const { uiState, setUIState } = useUiState();
  const { prefersReducedMotion } = uiState;

  const isExternal =
    (!!to && /^([a-z][a-z0-9+.-]*:|\/\/)/i.test(to)) || to.includes('.');

  const externalHref =
    isExternal && !/^([a-z][a-z0-9+.-]*:|\/\/)/i.test(to)
      ? `https://${to}`
      : to;

  if (isExternal) {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={externalHref}
        {...props}
      >
        {children}
      </a>
    );
  }

  const handleClick = () => {
    setUIState({
      isNavOpen: false,
      canTransition: prefersReducedMotion ? false : transition,
      // Used to indicate to user where they came from because the same page can be located in different menu items
      whereIcameFrom: uiState.megaMenuIndex,
    });
  };

  return (
    <NextLink
      href={to}
      scroll={prefersReducedMotion ? true : !transition}
      prefetch={false}
      {...props}
      onClick={handleClick}
    >
      {children}
    </NextLink>
  );
};
